import { render, staticRenderFns } from "./CoreanosDetail.vue?vue&type=template&id=781abfee&scoped=true"
import script from "./CoreanosDetail.vue?vue&type=script&lang=js"
export * from "./CoreanosDetail.vue?vue&type=script&lang=js"
import style0 from "./CoreanosDetail.vue?vue&type=style&index=0&id=781abfee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781abfee",
  null
  
)

export default component.exports